import { useMemo } from "react";
import { useStoredData } from "@/store";

export default function useGetOverlay() {
  const storedData = useStoredData();

  return useMemo(() => {
    const overlay = storedData.overlay ?? "";
    if (!["deposit", "withdraw", "filters", "rewards-apy", "transmute", "claim-rewards", "piggy-deposit", "piggy-harvest", "piggy-withdraw", "migrate"].includes(overlay)) {
      return undefined;
    }
    return storedData.overlay;
  }, [storedData.overlay]);
}
